import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: {
      xs: '0px',
      md: '48px',
    },
    '& .swiper-button-next': {
      visibility: 'hidden !important',
    },
    '& .swiper-button-prev': {
      visibility: 'hidden !important',
    },
    '& .swiper-slide': {
      maxWidth: {
        xs: '100% !important',
        md: '49% !important',
      },
    },
    '& .swiper-pagination': {
      position: 'relative !important',
      marginTop: '24px !important',
      bottom: 'unset !important',
      display: 'flex !important',
      justifyContent: 'center !important',
      alignItems: 'center !important',
      height: '24px !important',
      width: '100% !important',
    },
    '& .swiper-pagination-bullet': {
      backgroundColor: '#EAEFF5',
      opacity: '1 !important',
      width: '12px !important',
      height: '12px !important',
      margin: '0 6px !important',
      borderRadius: '50% !important',
      transition: 'all 0.3s ease !important',
      cursor: 'pointer !important',
      position: 'relative !important',
      flexShrink: '0 !important',
    },
    '& .swiper-pagination-bullet-active': {
      backgroundColor: 'primary.main',
      animation: 'blink 1.5s ease-in-out infinite !important',
      transform: 'scale(1.2) !important',
    },
  },
  wrapperSideNav: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: {
      xs: '16px',
      md: '24px',
    },
    '& .swiper-button-next': {
      visibility: 'hidden !important',
    },
    '& .swiper-button-prev': {
      visibility: 'hidden !important',
    },
    '& .swiper, & .swiper-wrapper': {
      width: '100% !important',
    },
    '& .swiper': {
      height: 'auto !important',
      overflow: 'hidden !important',
    },
    '& .swiper-wrapper': {
      alignItems: 'stretch',
    },
    '& .swiper-slide': {
      width: '100% !important',
      maxWidth: '100% !important',
      minWidth: '100% !important',
      flexShrink: '0 !important',
      height: 'auto !important',
      boxSizing: 'border-box',
    },
    '& .swiper-pagination': {
      position: 'relative !important',
      marginTop: '24px !important',
      bottom: 'unset !important',
      display: 'flex !important',
      justifyContent: 'center !important',
      alignItems: 'center !important',
      height: '24px !important',
      width: '100% !important',
    },
    '& .swiper-pagination-bullet': {
      backgroundColor: '#EAEFF5',
      opacity: '1 !important',
      width: '12px !important',
      height: '12px !important',
      margin: '0 6px !important',
      borderRadius: '50% !important',
      transition: 'all 0.3s ease !important',
      cursor: 'pointer !important',
      position: 'relative !important',
      flexShrink: '0 !important',
    },
    '& .swiper-pagination-bullet-active': {
      backgroundColor: 'primary.main',
      animation: 'blink 1.5s ease-in-out infinite !important',
      transform: 'scale(1.2) !important',
    },
  },
  carouselOverlay: {
    position: 'relative',
    width: '100%',
  },
  carouselOverlayAutoHeight: {
    position: 'relative',
    width: '100%',
    '& .swiper-pagination': {
      position: 'absolute !important',
      top: '100% !important',
      bottom: 'auto !important',
      left: 0,
      right: 0,
      marginTop: '24px !important',
    },
  },
  slidesViewport: {
    position: 'relative',
    width: '100%',
    '& .swiper': {
      height: 'auto !important',
    },
  },
  slidesViewportFullWidth: {
    position: 'relative',
    width: '100%',
    overflow: 'visible',
    '& .swiper': {
      height: 'auto !important',
      overflow: 'hidden !important',
    },
  },
  swiperContainer: {
    width: '100%',
    maxWidth: '100% !important',
  },
  swiperClipFullWidth: {
    width: '100%',
    maxWidth: '100% !important',
    overflow: 'hidden',
  },
  sideNavOverlay: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 3,
  },
  sideNavOverlaySlideAligned: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    zIndex: 5,
    pointerEvents: 'none',
    '& button': {
      pointerEvents: 'auto',
    },
  },
  sideNavOverlayPrev: {
    left: { xs: '16px', md: '24px' },
  },
  sideNavOverlayNext: {
    right: { xs: '16px', md: '24px' },
  },
  sideNavButton: {
    minWidth: { xs: '40px', md: '48px' },
    width: { xs: '40px', md: '48px' },
    height: { xs: '40px', md: '48px' },
    padding: 0,
    borderRadius: '50%',
    backgroundColor: 'custom.timerBackground',
    '&:hover': {
      backgroundColor: 'custom.timerBackground',
      opacity: 0.8,
    },
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
